import React from "react";
import { useWebOnboardingSteps } from "../hooks/useWebOnboardingSteps";

export const StepCounter = () => {
  const { stepCounterStep, totalSteps } = useWebOnboardingSteps();
  return !!stepCounterStep ? (
    <div className="cw-flex cw-items-center cw-text-center md:cw-body-base cw-body-sm cw-text-muted cw-my-4">
      Step {stepCounterStep} of {totalSteps}
    </div>
  ) : null;
};
